import axios from "axios";
import { SERVER_URL } from "Constants";

export type MonitorPaygPrice = {
	id: string;
	name: string;
	billingPeriod: number;
	billingAmount: number;
}

export type MotorVehicleSearchProductItem = {
	productDescription: string[];
	isPopular: boolean;
	code: string;
} & ConsumptionProductItem;

type ConsumptionProductItem = {
	id: string;
	name: string;
	price: number;
	description: string;
}

export async function getMonitorPaygPrice() {
	const url = `${SERVER_URL}/api/pricing/monitor-payg`;
	return await axios.get<MonitorPaygPrice>(url);
}

export async function getMotorVehicleSearchProducts() {
	const url = `${SERVER_URL}/api/entity/ServicePriceEntity/mvs-products`;
	return await axios.get<MotorVehicleSearchProductItem[]>(url);
}
